module.exports = __webpack_public_path__ + "static/media/16a-04_ST-2016-2032x3175mm-oleo-sobre-madera.b9149d1a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/16a/16a-04_ST-2016-2032x3175mm-oleo-sobre-madera.jpg
// module id = 186
// module chunks = 0